var app = {
	windowLoaded: function() {
		_main=this;				
		$('.preloader').fadeOut(800, function() {
			$(this).remove();
		});
	},	
	windowResized: function() {
		_main=this;
		_main.getViewport();
	},
	windowScrolled: function() {
		_main=this;
		// (_main.debug)?console.log('scroll'):'';
		_main.switchBg();
		_main.handlePath();

		sTop = $(window).scrollTop();

		if (sTop >= parseInt($(window).height()*0.2)) {
			$('.logo').addClass('scrolled');
		} else {
			$('.logo').removeClass('scrolled');
		}
	},	
	cookies: {		
		createCookie: function(name, value, days) {		    
		    _main=app;
		    var date = new Date();
		    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
		    var expires = "; expires=" + date.toGMTString();
		    document.cookie = name + "=" + value + expires + "; path=/";
		    (_main.debug)?console.log('creating cookie: ',name):'';
		},
		readCookie: function(name) {
		    _main=app;
		    var nameEQ = name + "=";
		    var ca = document.cookie.split(';');
		    for (var i = 0; i < ca.length; i++) {
		    	var c = ca[i];
		    	while (c.charAt(0) == ' ') c = c.substring(1, c.length);
		    	if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
		    }
		    return null;
		},
		checkCookies: function() {
		    _main=app;
		    if (_main.cookies.readCookie(_main.cookieName) != 1) {
		      (_main.debug)?console.log('cookie %s is not created yet',_main.cookieName):'';
		      _main.cookies.notification('show');
		    } else {
		    	(_main.debug)?console.log('cookie %s already exists',_main.cookieName):'';
		    }
		    $('.closeNotification').on('click',function () {
		      _main.cookies.createCookie(_main.cookieName, 1, 365);
		      _main.cookies.notification('hide');
		    });
		},
		notification: function(state) {
			_main=app;
			switch (state) {
				case 'show':
					$('.footer').append('<div class="cookiesNotification"><p>'+_main.messages.cookies+'</p><p class="closeNotification">&times;</p></div>');
				break;
				case 'hide':					
					$('.cookiesNotification').fadeOut(300, function () {
				        $(this).remove();
				      });
				break;
			}
		}
	},	
	globalNavigation: function() {
		_main=this;
		console.log('gnav init');
		console.log('nav: ',_main.globalNavState);

		if ($('.hamburger').hasClass('return-home')) {

			window.location.replace(base_url);

		} else {

			$('.hamburger').toggleClass('is-active');
			if (_main.globalNavState) {									
				$('.gnav').removeClass('opened');			
				(_main.debug)?console.log('closing global nav'):'';
				_main.globalNavState=false;
			} else {
				$('.gnav').addClass('opened');
				(_main.debug)?console.log('opening global nav'):'';
				_main.globalNavState=true;	
			}

		}
	},
	popMessage: function(msg) {
        _main=this;        
        // ($('.loadingScreen').length())?$('.loadingScreen').fadeOut():'';
        if ($('.popMessage').length) {
        	$('.popMessage, .overlay').remove();
        }
        $('body').append('<figure class="popMessage">\
            <p>'+msg+'</p>\
            <div class="closePop">&times;</div>\
        </figure>\
		<div class="overlay"></div> \
        ');
	},  
	switchBg: function() {
		_main=this;
		if (_main.viewport != 'mobile') {
			sTop = $(window).scrollTop();
			$('#bodyBg').css('background-position-y', (sTop*0.65)*-1);
		}
	},
	scrollEvents: function() {
		if (_main.viewport == 'desktop') {			
			
			$('#triggerAbout').waypoint({
				handler: function(direction) {						
					if (direction == 'down') {				
						(_main.debug)?console.log('about hello'):'';
						$('#sectionAbout').removeClass('hideThat');
					} else {				
						(_main.debug)?console.log('about bye'):'';
						$('#sectionAbout').addClass('hideThat');
					}
				},
				offset: '50%'
			});
			$('#triggerItem1').waypoint({
				handler: function(direction) {						
					if (direction == 'down') {
						(_main.debug)?console.log('item1 hello'):'';
						$('#item1').removeClass('notYet');
					} else {				
						(_main.debug)?console.log('item1 bye'):'';
						$('#item1').addClass('notYet');
					}
				},
				offset: '35%'
			});
			$('#triggerItem2').waypoint({
				handler: function(direction) {						
					if (direction == 'down') {
						(_main.debug)?console.log('item2 hello'):'';
						$('#item2').removeClass('notYet');
					} else {				
						(_main.debug)?console.log('item2 bye'):'';
						$('#item2').addClass('notYet');
					}
				},
				offset: '35%'
			});
			$('#triggerItem3').waypoint({
				handler: function(direction) {						
					if (direction == 'down') {
						(_main.debug)?console.log('item3 hello'):'';
						$('#item3').removeClass('notYet');
					} else {				
						(_main.debug)?console.log('item3 bye'):'';
						$('#item3').addClass('notYet');
					}
				},
				offset: '35%'
			});
			$('#triggerItem4').waypoint({
				handler: function(direction) {						
					if (direction == 'down') {
						(_main.debug)?console.log('item4 hello'):'';
						$('#item4').removeClass('notYet');
					} else {				
						(_main.debug)?console.log('item4 bye'):'';
						$('#item4').addClass('notYet');
					}
				},
				offset: '35%'
			});
			$('#triggerItem5').waypoint({
				handler: function(direction) {						
					if (direction == 'down') {
						(_main.debug)?console.log('item5 hello'):'';
						$('#item5').removeClass('notYet');
					} else {				
						(_main.debug)?console.log('item5 bye'):'';
						$('#item5').addClass('notYet');
					}
				},
				offset: '35%'
			});
			$('#triggerItem6').waypoint({
				handler: function(direction) {						
					if (direction == 'down') {
						(_main.debug)?console.log('item6 hello'):'';
						$('#item6').removeClass('notYet');
					} else {				
						(_main.debug)?console.log('item6 bye'):'';
						$('#item6').addClass('notYet');
					}
				},
				offset: '35%'
			});
			$('#triggerMenu').waypoint({
				handler: function(direction) {						
					if (direction == 'down') {
						(_main.debug)?console.log('menu hello'):'';
						$('#sectionMenu .tables').removeClass('hideThat');
					} else {
						(_main.debug)?console.log('menu bye bye'):'';
						$('#sectionMenu .tables').addClass('hideThat');
					}
				},
				offset: '15%'
			});
			$('#triggerContact').waypoint({
				handler: function(direction) {						
					if (direction == 'down') {
						(_main.debug)?console.log('contact hello'):'';
						$('#innerContact').removeClass('hideThat');
					} else {
						(_main.debug)?console.log('contact bye bye'):'';
						$('#innerContact').addClass('hideThat');
					}
				},
				offset: '20%'
			});
			$('#triggerPartners').waypoint({
				handler: function(direction) {						
					if (direction == 'down') {
						(_main.debug)?console.log('contact hello'):'';
						$('#partnersContainer').removeClass('hideThat');
					} else {
						(_main.debug)?console.log('contact bye bye'):'';
						$('#partnersContainer').addClass('hideThat');
					}
				},
				offset: '50%'
			});
		}
	},
	handleVideo: function() {
		_main=this;
		if (_main.videoState == false) {
			$('.videoBox').fadeIn().html('<iframe id="videoFrame" width="560" height="315" src="https://www.youtube-nocookie.com/embed/'+_main.videoURL+'?controls=0&autoplay=1" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>');
			$('.closeVideo').fadeIn();
			_main.videoState = true;

			var url = $("#txtUrl").val();
			url = url.split('v=')[1];
			$("#video")[0].src = "https://www.youtube.com/embed/" + url + "?autoplay=1";
			$("#video").show();
		} else {
			
		}
	},
	killVideo: function() {
		$('.videoBox').fadeOut().html();
		$('.videoBox iframe').remove();
		$('.closeVideo').fadeOut();
		_main.videoState = false;
	},
	handlePath: function() {
		_main=this;
/*
		var l = thePath.getTotalLength();
var dasharray = l;
track.style.strokeDasharray = dasharray;
var dashoffset = l;
track.style.strokeDashoffset = dashoffset;
$(document).on('scroll', function() {
  // - 10 is because I want to offset slightly the dashoffse
  dashoffset =
    -10 + l - document.documentElement.scrollTop * l / (document.documentElement.scrollHeight - document.documentElement.clientHeight);
  
    track.style.strokeDashoffset = dashoffset;
});
*/
		

		if (_main.viewport != 'mobile') {
			
			_main.debug?console.log('handle path init'):'';

			if ($(window).scrollTop() >= $('.hero').height() + $('.about').height()) {

				(_main.debug)?console.log('handle path'):'';

				var path = document.querySelector('#star-path');

				var pathLength = path.getTotalLength();
				// var pathLength = 5048;
				
				// path.style.strokeDasharray = pathLength + ' ' + pathLength;
				// path.style.strokeDasharray = '5048 5048';

				// path.style.strokeDashoffset = pathLength;
				// console.log('l: ',pathLength);

				// https://jakearchibald.com/2013/animated-line-drawing-svg/
				path.getBoundingClientRect();

				// window.addEventListener("scroll", function(e) {
			
				// https://stackoverflow.com/questions/2387136/cross-browser-method-to-determine-vertical-scroll-percentage-in-javascript/2387222#2387222
				
				// $('.hero').height() + $('.about').height()
				scrTop = document.documentElement.scrollTop - $('.hero').height() + $('.about').height();
				
				// console.log('scrTop: ',scrTop);
				var scrollPercentage = (scrTop + document.body.scrollTop) / (document.documentElement.scrollHeight - document.documentElement.clientHeight);

				// console.log('SCR PERC: ',scrollPercentage);
				
				var drawLength = (pathLength * 1.85 * scrollPercentage) - 1200;
				
				console.log('path length', pathLength);
				(_main.debug)?console.log('draw length', drawLength):'';
				
				path.style.strokeDashoffset = pathLength - drawLength;
					
				
				if (scrollPercentage >= 0.99) {
					// path.style.strokeDasharray = "none";
					
				} else {
					// path.style.strokeDasharray = pathLength + ' ' + pathLength;
					// path.style.strokeDasharray = '5048 5048';
				}
				
				// });

			} else {
				// (_main.debug)?console.log('out of range'):'';
			}

		}

		
	},
	// handleMap: function() {

	// 	_main.debug?console.log('init map'):'';

	// 	setTimeout(function(){
	
	// 		var map;
				
    //     			map = new google.maps.Map(
	// 				document.getElementById('map'),
	// 				{
	// 					center: new google.maps.LatLng(52.209477, 21.0017114),
	// 					zoom: 11,
	// 					styles: [{"featureType":"all","elementType":"geometry.fill","stylers":[{"weight":"2.00"}]},{"featureType":"all","elementType":"geometry.stroke","stylers":[{"color":"#9c9c9c"}]},{"featureType":"all","elementType":"labels.text","stylers":[{"visibility":"on"}]},{"featureType":"landscape","elementType":"all","stylers":[{"color":"#f2f2f2"}]},{"featureType":"landscape","elementType":"geometry.fill","stylers":[{"color":"#ffffff"}]},{"featureType":"landscape.man_made","elementType":"geometry.fill","stylers":[{"color":"#ffffff"}]},{"featureType":"poi","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"road","elementType":"all","stylers":[{"saturation":-100},{"lightness":45}]},{"featureType":"road","elementType":"geometry.fill","stylers":[{"color":"#eeeeee"}]},{"featureType":"road","elementType":"labels.text.fill","stylers":[{"color":"#7b7b7b"}]},{"featureType":"road","elementType":"labels.text.stroke","stylers":[{"color":"#ffffff"}]},{"featureType":"road.highway","elementType":"all","stylers":[{"visibility":"simplified"}]},{"featureType":"road.arterial","elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"transit","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"water","elementType":"all","stylers":[{"color":"#46bcec"},{"visibility":"on"}]},{"featureType":"water","elementType":"geometry.fill","stylers":[{"color":"#c8d7d4"}]},{"featureType":"water","elementType":"labels.text.fill","stylers":[{"color":"#070707"}]},{"featureType":"water","elementType":"labels.text.stroke","stylers":[{"color":"#ffffff"}]}]
	// 				});


	// 			var iconBase =
	// 			'https://developers.google.com/maps/documentation/javascript/examples/full/images/';

	// 			var icons = {
	// 			info: {
	// 				icon: base_url + 'assets/img/_common/marker.png'
	// 			}
	// 			};

	// 			var features = [
	// 				{
	// 				position: new google.maps.LatLng(52.2094776, 21.0017114),
	// 				type: 'info'
	// 				}, {
	// 				position: new google.maps.LatLng(52.2014988, 21.0144496),
	// 				type: 'info'					
	// 				}, {
	// 				position: new google.maps.LatLng(52.2581366, 20.9672516),
	// 				type: 'info'
	// 				}
	// 			];


	// 			// Create markers.
	// 			for (var i = 0; i < features.length; i++) {
	// 				var marker = new google.maps.Marker({
	// 				  position: features[i].position,
	// 				  icon: icons[features[i].type].icon,
	// 				  map: map
	// 				});
	// 			  };

	// 	}, 1000);
	// },
	events: function() {
		_main=this;
		
		$('.langSwitch a').on('click', function(e) {
			// e.preventDefault();
		});
		$('body').on('click', '.closePop', function() {
			$('.popMessage, .overlay').remove();
		});
		
        $('.hamburger').on('click', function() {        	
        	_main.globalNavigation();        	
        });
       	
		$('.gnav li').on('click', function() {
			target = $(this).attr('data-target');
			$("html, body").animate({            	
            	scrollTop: $(target).offset().top
			}, "slow"); 
			_main.globalNavigation();
		});

		$('.playBtn').on('click', function() {
			_main.handleVideo();
		});
		$('.closeVideo').on('click', function() {
			_main.killVideo();
		});

		$('.navLogo, .logo').on('click', function(e) {
			// e.preventDefault();
			$("html, body").animate({            	
            	scrollTop: 0
			}, "fast"); 
		});
	},	
	handleSlider: function(item) {
		_main=this;
		if (item == 'logos') {
			if (_main.viewport == 'mobile') {
				_main.debug?console.log('slider init: ',item):'';
				$('.logos').slick({
					arrows: false,
					autoplay: true,
					autoplaySpeed: 400,
					slidesToShow: 2
				});
			}
		}
	},
	ga_event: function($action,$category,$label) {
        _main=this;        
        gtag('event', $action, {
		  'event_category' : $category,
		  'event_label' : $label
		});
    },
	getBodyId: function() {
		_main=this;
		_main.bodyId=$('body').attr('id');
		(_main.debug)?console.log('body id: ',_main.bodyId):'';		
	},
	getViewport: function() {
		_main=this;
		wh=$(window).width();
		if (wh<=_main.breakpointMobile) {
			_main.viewport='mobile';			
		} else if (wh>_main.breakpointMobile && wh<=_main.breakpointTablet) {
			_main.viewport='tablet';
		} else {
			_main.viewport='desktop';
		}
		(_main.debug)?console.log('viewport: ',_main.viewport):'';		
	},
	loadScript: function(path) {
		_main=this;
		$.ajax({
		  	url: path,
		  	dataType: 'script',
		  	cache: true, // or get new, fresh copy on every page load
		  	success: function() {
		    	(_main.debug)?console.log('external script successfully loaded: ',path):'';
		  	},
	        error: function(msg) {
	            (_main.debug)?console.log('error while loading external script: ',msg):'';
	        }
		});
	},
	messages: {
		'sendFormSuccess': 'Dziękujemy, wiadomość została wysłana.',
		'sendFormError': 'Wystąpił błąd podczas wysyłania wiadomości. Prosimy o sprawdzenie poprawności wprowadzonych danych i spróbowanie ponownie.',		
		'uknkown': 'Wystąpił nieprzewidziany błąd aplikacji',		
		'cookies': 'Na naszej stronie używamy plików cookies w celach statystycznych. Aby dowiedzieć się na czym to polega, kliknij w ten <a href="'+base_url+'informacje/informacje-prawne#cookies">link</a>.',
		'ajaxError': 'Wystąpił błąd podczas połączenia z serwerem.',
		'pleaseWait': 'Proszę czekać...'
	},
	init: function() {
		_main=this;
		_main.getViewport();
		_main.getBodyId();
		_main.events();		
		_main.handleSlider('logos');
		_main.scrollEvents();		
		// _main.handleMap();		
		_main.cookies.checkCookies();
	},

	debug: false,
	debugOutput: false,
	viewport: null,
	cookieName: 'CiaoATutti',
	visitorType: null,
	videoURL: 'EA0AP6lu3ks',
	videoState: false,

	globalNavState: false,
	currentVideoState: null,
	bodyClass: null,
	bodyId: null,	

	breakpointMobile: 640,
	breakpointTablet: 1100
}

$(document).ready(function() {
	app.init();	
});

$(window).on('load', function() {
	app.windowLoaded();
});

$(window).resize(function() {
	app.windowResized();
});

$(document).scroll(function() {
	app.windowScrolled();
});
